import { render, staticRenderFns } from "./ShippingSubModal.vue?vue&type=template&id=683ef09e&scoped=true&"
import script from "./ShippingSubModal.vue?vue&type=script&lang=js&"
export * from "./ShippingSubModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ef09e",
  null
  
)

export default component.exports